import { NgModule } from '@angular/core';

import { EventBannerComponent } from '@main-client/src/app/events/event-banner/event-banner.component';

@NgModule({
  declarations: [EventBannerComponent],
  exports: [EventBannerComponent],
})
export class EventBannerModule {}
